// Information about CSUS club metrics
import events  from '../images/metrics/event-icon.svg'
import heart  from '../images/metrics/heart-icon.svg'
import people  from '../images/metrics/people-icon.svg'

const metrics = [
    {
        icon: events,
        title: "30+ executive members",
        description: "This year, we have a team of over 30 exec members. Apply for exec positions over the summer!"
    },
    {
        icon: heart,
        title: "25+ club events",
        description: "Throughout the semester, CSUS runs club events ranging from exam prep to socials."
    },
    {
        icon: people,
        title: "100+ members",
        description: "We have a total of over 100 signed up CSUS members! Register through USC."
    }
]

export default metrics;